const localConfig = {
    AON_URL: 'https://olsbeta.mypaymentsecurity.com/authorize',
    API_HOST: 'https://api-qa.syf.com',
    APP_ENV: 'development',
    ASSETS_HOST: 'https://qa.synchronycredit.com',
    AUTH_DOMAIN: 'https://auth-qa.syf.com'
};
const config = {
    AON_URL: 'CF_AON_URL',
    API_HOST: 'CF_API_HOST',
    APP_ENV: 'CF_APP_ENV',
    ASSETS_HOST: 'CF_ASSETS_HOST',
    AUTH_DOMAIN: 'CF_AUTH_DOMAIN'
};
export default process.env.NODE_ENV === 'production' ? config : localConfig;
